import React from 'react';

import * as helpers from './helpers';

const StonesIcon = ({
  color,
  width = 30,
  height = 22,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    fill="none"
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <path
      d="M23 1H6.875L2 6.78261L15 20L28 6.78261L23 1Z"
      stroke={color}
      strokeWidth={1.5}
    />
  </svg>
);

export default StonesIcon;
